import React from 'react'
import PubSub from 'pubsub.js'

export enum messageTypes {
  onSceneChanged,
  onChapterChanged,
  onScrollToScene,
  onHighlightedRegionChanged,
  onScrollToTop,
  onDeviceChanged,
  onResized,
  onWarningBannerClosed
}

abstract class IEventedComponent<P, S> extends React.Component<P, S> {
  tokens: any[] = []

  subscribe = (messageType: messageTypes, func: Function) => {
    this.tokens.push(PubSub.subscribe(messageType.toString(), func))
  }

  publish<T>(messageType: messageTypes, msg?: T) {
    PubSub.publish(messageType.toString(), [msg])
  }

  componentWillUnmount() {
    this.tokens.forEach(x => PubSub.unsubscribe(x))
    this.tokens = []
  }
}

export default IEventedComponent
